import { render, staticRenderFns } from "./CreditorsDisplay.vue?vue&type=template&id=ec08ee34&scoped=true"
import script from "./CreditorsDisplay.vue?vue&type=script&lang=js"
export * from "./CreditorsDisplay.vue?vue&type=script&lang=js"
import style0 from "./CreditorsDisplay.vue?vue&type=style&index=0&id=ec08ee34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec08ee34",
  null
  
)

export default component.exports